export default __webpack_public_path__ + "09414ada7734c63553ba206d91e1ff6a.svg";